class CollapsibleFooter extends Collapsible {
  constructor() {
    super();
    if (!this.options.breakpoint) {
      this.options.breakpoint = parseInt(768);
    }
    this.windowWidth = window.innerWidth;
    this.displayDetails();
  }

  construct() {
    super.construct();

    window.addEventListener('resize', () => {
      if (this.windowWidth == window.innerWidth) {
        return;
      }
      this.windowWidth = window.innerWidth;
      this.displayDetails();
    });
  }

  open(group) {
    if (window.innerWidth < this.options.breakpoint) {
      super.open(group);
    }
  }

  close(group) {
    if (window.innerWidth < this.options.breakpoint) {
      super.close(group);
    }
  }

  displayDetails() {
    if (window.innerWidth >= this.options.breakpoint) {
      this.openAll();
    } else {
      this.closeAll();
    }
  }
}

if (!customElements.get('collapsible-footer')) {
  customElements.define('collapsible-footer', CollapsibleFooter);
}

document.addEventListener('DOMContentLoaded', function () {
  const footerElement = document.querySelector('.footer__container');

  // Function to push data to the dataLayer
  function pushDataLayerOnClick(clickTitle) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'FooterClick',
      pageType:
        document.querySelector('[data-template-class]').dataset.templateClass || 'undefined',
      pageURL: window.location.href || 'undefined',
      clickTitle: clickTitle,
    });
    debug() && console.log('Footer on click: ', clickTitle, window.dataLayer);
  }

  // Attach event listeners to all buttons and links within the footer
  footerElement.querySelectorAll('a, button').forEach(function (element) {
    element.addEventListener('click', function () {
      const clickTitle = this.innerText || 'Undefined';
      pushDataLayerOnClick(clickTitle.trim());
    });
  });

  // Handling for Trustpilot widget iframe
  const trustpilotIframe = footerElement.querySelector('.trustpilot');
  if (trustpilotIframe) {
    trustpilotIframe.addEventListener('click', function () {
      pushDataLayerOnClick('Trustpilot Widget');
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const footerSuccess = document.querySelector('#footer-success');

  // When element exists, push the dataLayer
  if (footerSuccess) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'Subscribe',
      pageType:
        document.querySelector('[data-template-class]').dataset.templateClass || 'undefined',
      pageURL: window.location.href || 'undefined',
      formLocation: 'footer',
    });
    debug() && console.log('Footer on submit: ', window.dataLayer);
  }
});
